import { Field } from 'react-final-form';

const identity = (value) => value;

export const IdentityField = ({ gridSpan, ...props }: any) => {
  if (gridSpan) {
    return (
      <div style={{ gridColumn: `span ${gridSpan}` }}>
        <Field parse={identity} {...props} />
      </div>
    );
  } else return <Field parse={identity} {...props} />;
};
